import { useNavigate } from "react-router-dom";
import CancelIcon from "@mui/icons-material/Cancel";
import ReplayIcon from "@mui/icons-material/Replay";
import { Header } from "../../components/landing/header";
import { Footer } from "../../components/landing/footer";
import "./PaymentCancel.css";

export const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    // Navigate back to coupons page where they can try subscribing again
    navigate("/coupons/profile");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  const handleContactSupport = () => {
    // Navigate to home page contact section
    window.location.href = "/#contact";
  };

  return (
    <>
      <Header />
      <section className="payment-section payment-cancel-section">
        <div className="container">
          <div className="payment-card">
            <div className="payment-icon-container payment-icon-cancel">
              <CancelIcon />
            </div>
            <h2 className="payment-title">Payment Cancelled</h2>
            <p className="payment-message">
              Your payment was not completed. Don't worry - no charges have been
              made to your account. You can try again whenever you're ready.
            </p>

            <div className="cancel-info-box">
              <h4 className="cancel-info-title">Why Subscribe?</h4>
              <ul className="cancel-benefits-list">
                <li>Unlimited coupon creation</li>
                <li>Access to all templates and features</li>
                <li>One-time payment of $65 - no recurring charges</li>
                <li>Lifetime access to current features</li>
              </ul>
            </div>

            <div className="payment-btn-container">
              <button className="theme-btn payment-btn-primary" onClick={handleTryAgain}>
                <ReplayIcon style={{ marginRight: "8px", fontSize: "20px" }} />
                Try Again
              </button>
              <button className="theme-btn white-btn payment-btn-secondary" onClick={handleGoHome}>
                Back to Home
              </button>
            </div>

            <p className="cancel-support-text">
              Having trouble? <span onClick={handleContactSupport}>Contact our support team</span>
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
